<template>
  <section id="tramites-principales" class="t-main" aria-labelledby="guia-tramites-principales-title">
    <h2 id="guia-tramites-principales-title" class="wd-title">
      <span class="t-main__base">Trámites</span> <span class="hl">principales</span>
    </h2>

    <div class="t-main__grid">
      <article v-for="item in items" :key="item.id" class="t-main__card">
        <img :src="item.icon" alt="" aria-hidden="true" />
        <h3 class="t-main__title" v-html="item.title" />
        <p class="wd-body">{{ item.description }}</p>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import incrementoIcon from '../../../assets/tramites-figma/ic-incremento.svg'
import beneficiariosIcon from '../../../assets/tramites-figma/ic-beneficiarios.svg'
import domiciliacionIcon from '../../../assets/tramites-figma/ic-domiciliacion.svg'
import facturacionIcon from '../../../assets/tramites-figma/ic-facturacion.svg'
import ayudaIcon from '../../../assets/tramites-figma/ic-ayuda.svg'

const items = [
  {
    id: 'incremento',
    icon: incrementoIcon,
    title: 'Incremento',
    description:
      'Actualiza el monto inicial de tu contrato hasta por $500,000 durante la etapa de Integrante, si necesitas mayor capacidad para comprar, construir, remodelar o adquirir más de un inmueble.'
  },
  {
    id: 'beneficiarios',
    icon: beneficiariosIcon,
    title: 'Cambio de beneficiarios',
    description:
      'Puedes realizar el cambio o designación de beneficiarios de tu contrato durante la etapa de Integrante, de acuerdo con las condiciones y requisitos establecidos.'
  },
  {
    id: 'domiciliacion',
    icon: domiciliacionIcon,
    title: 'Domiciliación bancaria',
    description:
      'Puedes domiciliar el pago de tu cuota periódica para que se realice automáticamente desde una cuenta bancaria, ayudándote a evitar olvidos y posibles recargos.'
  },
  {
    id: 'facturacion',
    icon: facturacionIcon,
    title: 'Facturación <br class="br-d">(CFDI 4.0)',
    description:
      'Recibe tus facturas fiscales correspondientes a tus pagos, de acuerdo con los datos fiscales que proporciones y los requisitos aplicables.'
  },
  {
    id: 'ayuda',
    icon: ayudaIcon,
    title: '¿Cómo te ayudan <br class="br-d">estos tramites?',
    description:
      'Estos trámites te permiten mantener actualizada tu información, facilitar tus pagos y realizar ajustes a tu contrato conforme cambien tus necesidades.'
  }
]
</script>

<style scoped>
.t-main {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-7);
}
.t-main__base {
  color: var(--ds-purple-900);
}

.t-main__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--ds-space-4);
  align-items: start;
}

.t-main__card {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  align-self: stretch;
  padding: var(--ds-space-4) var(--ds-space-3);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 24px;
}
.t-main__card:last-child {
  align-self: start;
}
.t-main__card img {
  width: 40px;
  height: 40px;
}
.t-main__title {
  min-height: 48px;
  margin: 0;
  color: var(--ds-text-body);
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

@media (max-width: 1024px) {
  .t-main {
    gap: var(--ds-space-6);
  }
}

@media (max-width: 599px) {
  .t-main__grid {
    grid-template-columns: 1fr;
    gap: var(--ds-space-6);
  }
  .t-main__card {
    padding: var(--ds-space-4);
  }
  .t-main__title {
    min-height: 0;
  }
}
</style>
